import IntlProps from "../../state/helpers/IntlProps"
import {
    getItemQuantities, getOptionalItemSelection,
} from "../../state/selection/selectionSelectors"
import {
    editItemQuantity, toggleOptionalItem,
} from "../../state/selection/selectionActions"
import {connect, ConnectedProps} from "react-redux"
import {defineMessages, FormattedMessage, injectIntl} from "react-intl"
import React from "react"
import {ProposalItemDto} from "../../state/proposal/Proposal"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import Checkbox from "../../common/checkbox/checkbox.component"
import Icon from "../../common/icon/icon.component"

const messages = defineMessages({
    modal_optional_items_label: {
        id: "price_list.configure_price_list_modal.optional_items",
        defaultMessage: "Optional items"
    },
    modal_optional_include_label: {
        id: "proposal.items.option_label",
        defaultMessage: "Include"
    },
    modal_optional_selected_label: {
        id: "proposal.items.option_selected_label",
        defaultMessage: "Selected"
    },
})

type OwnProps = {
    optionalItems: ProposalItemDto[]
}


const OptionalItemSelectionComponent = (props: Props & IntlProps) => {

    const getItemQuantity = (item: ProposalItemDto): string => {
        const editableItem = props.itemQuantities.find(i => i.itemId === item.id)
        return editableItem ? editableItem.measure : item.measure
    }

    const isSelected = (id) => {
        return props.itemSelection.includes(id)
    }

    return (
        <div className="mb-3">
            <h5>
                <FormattedMessage {...messages.modal_optional_items_label}/>
            </h5>
            {props.optionalItems.map(item => {
                return (
                    <>
                        <div className="form-group form-row border-bottom border-top py-2 mb-0">
                            <div className="col-2">
                                <InputUnitOfMeasure
                                    name={"measure"}
                                    value={getItemQuantity(item)}
                                    onChange={measure => {props.editItemQuantity(item.id, measure)}}
                                    disabled={(!isSelected(item.id) || !item.isEditableQuantity)}
                                    id={"measure"}
                                />
                            </div>

                            <label className="col-7 col-form-label text-align-left">
                                <span className="ml-3">
                                    {item.title}
                                </span>
                            </label>

                            <div className="col-3 align-self-center d-flex justify-content-end">
                                {!isSelected(item.id) ?
                                    <label className="mb-0" htmlFor={"option-" + item.id} style={{cursor: "pointer"}}>
                                        <h5 className="mb-0">
                                            <span className="badge badge-primary ">
                                                <Icon value={"plus"} className={"mr-1"}/>
                                                <FormattedMessage {...messages.modal_optional_include_label}/>
                                            </span>
                                        </h5>
                                    </label> :

                                    <label className="mb-0" htmlFor={"option-" + item.id} style={{cursor: "pointer"}}>
                                        <h5 className="mb-0">
                                            <span className="badge badge-primary bg-success">
                                                <FormattedMessage{...messages.modal_optional_selected_label}/>
                                            </span>
                                        </h5>
                                    </label>
                                }

                                <Checkbox
                                    style={{cursor: "pointer", marginBottom: "0.1rem"}}
                                    className={"ml-1"}
                                    size={3}
                                    Thickness={2}
                                    id={"option-" + item.id}
                                    checked={isSelected(item.id)}
                                    onChange={() => {props.toggleOptionalProduct(item.id)}}/>
                            </div>
                        </div>
                    </>
                )
            })
            }
        </div>
    )
}


const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        itemQuantities: getItemQuantities(state),
        itemSelection: getOptionalItemSelection(state),
    }
}
const mapDispatch = {
    editItemQuantity,
    toggleOptionalProduct: toggleOptionalItem,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(OptionalItemSelectionComponent))


// WEBPACK FOOTER //
// ./src/price-list/components/OptionalItemSelectionComponent.tsx